import { AxiosRequestConfig } from "axios";
import client from "libs/HttpClient";

interface ListPayoutRequest {
  queryKey: [string, string, string];
}

/**
 * Service class for handling Common.
 */
class PayoutService {
  /**
   * get Payout List based on the provided request.
   *
   * @param request - The request parameters for getting a Payout.
   * @returns A Promise that resolves to the Axios response for the update Payout request.
   */
  static getPayoutList(request: ListPayoutRequest) {
    const searchText = request.queryKey[0];
    const from_date = request.queryKey[1];
    const to_date = request.queryKey[2];
    return client.get(
      `admin/payout/payout-list?search_text=${searchText}&from_date=${from_date}&to_date=${to_date}`,
      request as AxiosRequestConfig
    );
  }
}

export { PayoutService };
